import { Box, Popover, Tag, Text, useToggle } from '@factorialco/deprecated-design-system'
import {
  AttendanceEditTimesheetRequestRequestTypeEnum,
  TimesheetEditTimesheetRequestFragment,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import {
  modalTextByRequest,
  renderChange,
} from 'modules/attendance/lib/editTimesheetRequestsDisplay'
import { locationTypeText } from 'modules/attendance/lib/locationType'
import AttendanceShift from 'modules/attendance/lib/utils/AttendanceShift'
import EditTimesheetRequestUtils from 'modules/attendance/lib/utils/EditTimesheetRequest'

interface Props {
  request: TimesheetEditTimesheetRequestFragment
}

const selectIcon = (requestType: AttendanceEditTimesheetRequestRequestTypeEnum) => {
  switch (requestType) {
    case 'create_shift':
      return 'add'
    case 'delete_shift':
      return 'delete'
    default:
      return 'pencil'
  }
}

const PendingRequestTag = ({ request }: Props) => {
  const [open, toggle] = useToggle(false)

  const shiftClockIn = request.attendanceShift
    ? AttendanceShift.clockInTimeStr(request.attendanceShift)
    : null
  const shiftClockOut = request.attendanceShift
    ? AttendanceShift.clockOutTimeStr(request.attendanceShift)
    : null
  return (
    <Popover.ItemList
      attachment="top center"
      targetAttachment="bottom center"
      toggle={toggle}
      open={open}
      title={modalTextByRequest(request).title}
    >
      <Box
        flexDirection="row"
        alignItems="center"
        alignSelf="flexStart"
        gap="s8"
        height="s48"
        key={request.id}
      >
        <Tag type={Tag.Types.champagne} leftItem="icon" icon={selectIcon(request.requestType)}>
          {i18n.t('clock_in.edit_timesheet_requests.pending')}
        </Tag>
      </Box>
      {!EditTimesheetRequestUtils.isDeleteShift(request) && (
        <Box alignItems="center" background="grey800">
          <ul>
            {!request.workable && (
              <li key={'break'} style={{ listStyleType: 'disc' }}>
                <Text.Normal weight="bold">
                  {i18n.t('dashboard.todo.approvals.attendance.break')}
                </Text.Normal>
              </li>
            )}
            {renderChange(
              i18n.t('dashboard.todo.approvals.attendance.clock_in'),
              'grey000White',
              shiftClockIn,
              request.clockIn
            )}
            {renderChange(
              i18n.t('dashboard.todo.approvals.attendance.clock_out'),
              'grey000White',
              shiftClockOut,
              request.clockOut
            )}
            {renderChange(
              i18n.t('dashboard.todo.approvals.attendance.location_type'),
              'grey000White',
              request.attendanceShift?.locationType &&
                locationTypeText(request.attendanceShift?.locationType),
              request.locationType && locationTypeText(request.locationType)
            )}
            {renderChange(
              i18n.t('dashboard.todo.approvals.attendance.observations'),
              'grey000White',
              request.attendanceShift?.observations,
              request.observations
            )}
          </ul>
        </Box>
      )}
    </Popover.ItemList>
  )
}

export default PendingRequestTag
